import { Theme, Tooltip, IconButton } from '@mui/material';
import CommentIcon from '@mui/icons-material/Comment';
import useCommentsContext from './useCommentsContext';

export default function ToggleCommentsButton() {
  const { showComments, onToggleComments } = useCommentsContext();
  return (
    <Tooltip title={showComments ? "Hide comments" : "Show comments"} placement="right">
      <IconButton
        sx={(theme:Theme) => ({
          position: 'fixed',
          top: 77, right: 24, // 37 = 16px gap + 21px half button size
          zIndex: 1050,
          '&:hover': {
            backgroundColor: theme.palette.primary.light,
          }
        })}
        color={showComments ? 'primary' : 'default'}
        onClick={onToggleComments}
      ><CommentIcon /></IconButton>
    </Tooltip>
  )
}
